import {getFilePreviewUrl, openDialog, showNotification} from 'platform/components';
import {match} from 'ts-pattern';

import {isFalse, isString, noop} from 'ramda-adjunct';

import {DOCUMENT_ACTION_COLUMNS} from '@dms/features/document-context';
import i18n from '@dms/i18n';
import {DmsDataGrid, downloadFile, printPDF, useEmailConfig} from '@dms/shared';
import {SendCustomerEmailForm} from '@dms/shared-aftersales';

import {openFile} from 'shared/web';

import type {ActionCallback} from 'features/eag-grid';

export function TireTransportDocumentsOverview() {
  const {isEnabled: isEmailConfigEnabled} = useEmailConfig();

  const actionCallback: ActionCallback<typeof DOCUMENT_ACTION_COLUMNS> = ({
    actionKey,
    rowId,
    getColumnData,
  }) => {
    const file = getColumnData<{remoteUrl: string; id: string; title: string; contentType: string}>(
      'fileName'
    );

    const contentType = file?.value?.contentType;
    const url = file?.value?.remoteUrl;
    const fileId = file?.value?.id;

    if (!(isString(url) && isString(rowId))) {
      showNotification.error();
      return;
    }

    const fileName = file?.value?.title ?? 'file';

    const previewUrl = getFilePreviewUrl(url, contentType);

    match(actionKey)
      .with('preview', 'openOnNewTab', () => openFile(previewUrl))
      .with('download', () => downloadFile(url, {fileType: 'attachment'}))
      .with('print', () => printPDF(previewUrl))
      .with('sendEmail', () => {
        if (!fileId) {
          showNotification.error();
          return;
        }

        if (isFalse(isEmailConfigEnabled)) {
          showNotification.error(i18n.t('general.notifications.setupEmailProvider'));
          return;
        }

        openDialog(
          <SendCustomerEmailForm
            recordId={rowId}
            defaultValues={{
              attachments: [
                {
                  fileId,
                  fileUrl: url,
                  fileName,
                  fileType: contentType ?? 'unknown',
                  shouldConvertToPdf: false,
                },
              ],
            }}
          />,
          {
            scrollBehavior: 'outside',
            size: 'large',
            title: i18n.t('general.actions.sendEmail'),
          }
        );
      })
      .otherwise(noop);
  };

  return (
    <DmsDataGrid
      gridCode="tire-transport-document"
      actionCallback={actionCallback}
      predefinedColumns={DOCUMENT_ACTION_COLUMNS}
    />
  );
}
